module.exports = {
  base: {
    useUrl: process.env.REACT_APP_USE_URL,
    // indexedDb: {
    //   name: 'blunex-mobile-indexed-db',
    // },
  },
  file: {
    useUrl: process.env.REACT_APP_FILE_URL,
  },
  urls: {
    // Account: {
    //   login: 'api/Account', // 로그인
    //   logout: 'api/Account/LogOut', // 로그아웃
    //   getLanguage: 'api/Account/GetLoginLan', // 언어 목록
    //   getFindId: 'api/Account/GetFindId', // ID 찾기
    //   getFindPw: 'api/Account/GetFindPw', // Password 찾기
    //   CheckUserId: 'api/Account/CheckUserId', // ID 중복 체크
    //   SpLoginR4: 'api/Account/SP_LOGIN_R4', // 지역별 현장 조회
    //   SpLoginU3: 'api/Account/SP_LOGIN_U3', // 회원가입 저장
    //   FindDep: 'api/Account/SP_GET_DEP_LAST', // 부서 조회
    //   SpLoginR5: 'api/Account/SP_LOGIN_R5', // 사업체 조회
    //   SP_LOGIN_U6: 'api/Account/SP_LOGIN_U6', // FTP UPLOAD
    //   CheckVersions: 'api/Account/CheckVersions', // 버전관리
    // },
    Execute: {
      execute: 'api/Execute/ExecuteProcedure', //프로시저 호출
      ftpRequest: 'api/Execute/FtpRequest', //FTP 업로드
      ftpResponse: 'api/Execute/FtpResponse', //FTP 다운로드
      videoUpload: 'api/Execute/VideoUpload', //파일서버 업로드
      UploadChunk: 'api/Execute/UploadChunk', //파일서버 대용량 업로드 - Chunk
      MergeChunks: 'api/Execute/MergeChunks', //파일서버 대용량 업로드 - MergeChunk
      UrlFileDownload: 'api/Execute/UrlFileDownload', //파일 다운로드
      DeleteFile: 'api/Execute/DeleteFile', //파일 삭제
      ConvertHwpToPdf: 'api/Execute/ConvertHwpToPdf', //한글 -> PDF 변환
      ConvertOfficeToPdf: 'api/Execute/ConvertOfficeToPdf', //오피스 -> PDF 변환
      moveAndReplaceFile: 'api/Execute/moveAndReplaceFile', //Preview 파일 이동/삭제
    },

    Account: {
      login: 'api/Account/GetToken', // 로그인
      GetInfo: 'api/Account/GetInfo', // 메뉴,언어정보
      logout: 'api/Account/LogOut', // 로그아웃
      getLanguage: 'api/Account/GetLoginLan', // 언어 목록
      getFindId: 'api/Account/GetFindId', // ID 찾기
      getFindPw: 'api/Account/GetFindPw', // Password 찾기
      CheckUserId: 'api/Account/CheckUserId', // ID 중복 체크
      getDepartments: 'api/Account/GetDepartments', // 부서 목록 조회
      searchSignupCompanies: 'api/Account/SearchSignupCompanies', // 회원가입 회사명 검색
      getSignupCusts: 'api/Account/GetSignupCusts', // 회원가입 사업장 목록 조회
      SpLoginR4: 'api/Account/SP_LOGIN_R4', // 지역별 현장 조회
      signUp: 'api/Account/SignUp', // 회원가입 저장
      SpLoginR5: 'api/Account/SP_LOGIN_R5', // 사업체 조회
      CheckVersions: 'api/Account/CheckVersions', // 버전관리
      CheckClientVersion: 'api/Account/CheckClientVersion', // 클라이언트 버전·API 정책
      CheckPassword: 'api/Account/ValidatePassword', // 비밀번호 확인
      ChangePassword: 'api/Account/ChangePassword', // 비밀번호 변경
      mokRequestPageUrl: 'api/mok_std_request', // MOBILEOK.process()용 이용기관 요청 페이지 경로
      updateIdentity: 'api/Account/UpdateIdentity', // 본인인증 정보 업데이트
      saveTempPassword: 'api/Account/SaveTempPassword', // 임시 비밀번호 발급
    },
    /* 공통 유틸 */
    Utility: {
      getMember: 'api/Utility/GetMember', //
      getMenu: 'api/Utility/GetMenu', //메뉴 조회
      getTab: 'api/Utility/GetTab', //탭 조회
      getMenuDescription: 'api/Utility/GetMenuDescription', //메뉴 정보 조회
      getVersion: 'api/Utility/GetVersion', //버젼 조회
      getDepLast: 'api/Utility/GetDepLast', //마지막 부서 조회
      getCompanyInfo: 'api/Utility/GetCompanyInfo', //회사 정보 조회 SP_GetNotice_R1
      getCustomerInfo: 'api/Utility/GetCustomerInfo', //업체 정보 조회
      getIndustryInfo: 'api/Utility/GetIndustryInfo', //업종 정보 조회
      getAuthInfo: 'api/Utility/GetAuthInfo', //권한 정보 조회
      saveActionLog: 'api/Utility/SaveActionLog', //저장 액션 로그 저장
      getCodeInfo: 'api/Utility/GetCodeInfo', //코드 정보 조회
      getDepManager: 'api/Utility/GetDepManager', //부서 관리자 정보 조회
      getCustManager: 'api/Utility/GetCustManager', //사업장 관리자 정보 조회
      GetSafetyManager: 'api/Utility/GetSafetyManager', //안전 관리자 정보 조회
      getManager: 'api/Utility/GetManager', // 사업장 관리자 + 총괄관리자 조회
      getMemberListR1: 'api/Utility/GetMemberListR1', // 회원 목록 (ALL/CO/CUST/DEP)
      getGongjongList: 'api/Gongjong/GetGonBasicR1', // 공정 조회 (부서코드 기준)
    },
    /* 홈 */
    Home: {
      getHomeData: 'api/Home/GetHomeData', //홈 조회
    },
    Depart: {
      getDepBasicR1: 'api/Depart/GetDepBasicR1', //부서 목록 조회
    },
    /* TBM (프로시저명 기반 전용 API) */
    TBM: {
      getTbmR1: 'api/TBMCustom/GetTbmR1', // TBM_CD 조회 SP_TBM_R1
      getTbmR2: 'api/TBMCustom/GetTbmR2', // 동영상/TBM_CD 조회 SP_TBM_R2
      getTbmR4: 'api/TBMCustom/GetTbmR4', // TBM 참석인원 조회 SP_M20903_R1
      getTbmCustomR1: 'api/TBMCustom/GetTbmCustomR1', // TBM_CD 조회 SP_TBM_CUSTOM_R1
      getTbmCustomR2: 'api/TBMCustom/GetTbmCustomR2', // 최신 교육자료 조회 SP_TBM_CUSTOM_R2
      getTbmCustomR3: 'api/TBMCustom/GetTbmCustomR3', // 작업허가서 조회 SP_TBM_CUSTOM_R3
      getTraCustom04R4: 'api/TBMCustom/GetTraCustom04R4', // 교육 동영상 조회 SP_TRA_CUSTOM_04_R4
      getTraCustom04R2: 'api/TBMCustom/GetTraCustom04R2', // 교육 파일 조회 SP_TRA_CUSTOM_04_R2
      getSafBasic01R1: 'api/TBMCustom/GetSafBasic01R1', // 작업계획서(BASIC) 조회 SP_SAF_BASIC_01_R1
      getTbmStatusR1: 'api/TBMCustom/GetTbmStatusR1', // 교육현황 조회 SP_TBM_STATUS_R1
      saveTbmU1: 'api/TBMCustom/SaveTbmU1', // TBM 회의 시작시간 저장 SP_TBM_U1
      saveTbmBasicU2: 'api/TBMCustom/SaveTbmBasicU2', // 추가회의 저장 SP_M20906_U1
      saveTbmBasicU3: 'api/TBMCustom/saveTbmBasicU3', // SP_M20907_U1
      saveTbmBasicU4: 'api/TBMCustom/saveTbmBasicU4', // TBM 완료 저장 SP_M20908_U1
      saveTbmBasicU5: 'api/TBMCustom/SaveTbmBasicU5', // TBM 참석자 저장 SP_TBM_MEMBER_U1
      saveTbmBasicU6: 'api/TBMCustom/SaveTbmBasicU6', // TBM 참석자 완료 저장 SP_M10605_U1
      saveTbmStatusU1: 'api/TBMCustom/SaveTbmStatusU1', // 교육현황 저장 SP_TBM_STATUS_U1
      saveTbmCustomU1: 'api/TBMCustom/SaveTBMCustomU1', // TBM 자료 및 내역 저장 SP_TBM_CUSTOM_U1
      deleteTbmD1: 'api/TBMCustom/DeleteTbmD1', // TBM 삭제 SP_TBM_D1
      deleteTbmD2: 'api/TBMCustom/DeleteTbmD2', // TBM 참석 취소 SP_TBM_MEMBER_D2
    },
    /* TBM 이수현황 */
    TBMCompletionStatus: {
      getTcsBasicR1: 'api/TcsBasic/GetTcsBasicR1', // TBM 이수현황 조회
    },
    /* ToolBoxMeeting */
    ToolBoxMeeting: {
      getTraCustom04R4: 'api/TraCustom/GetTraCustom04R4', // 교육 동영상 조회 SP_TRA_CUSTOM_04_R4
      getTraCustom04R2: 'api/TraCustom/GetTraCustom04R2', // 교육 파일 조회 SP_TRA_CUSTOM_04_R2
      getSamBasic01R1: 'api/SamBasic/GetSamBasic01R1', // 작업계획서(CUSTOM) 조회 SP_SAM_BASIC_01_R1
      getSamBasic02R4: 'api/SamBasic/GetSamBasic02R4', // 안전작업허가서 마스터 목록 조회
      getSamBasic02R5: 'api/SamBasic/GetSamBasic02R5', // 안전작업허가서 데일리 목록 조회
      getTbmNewR1: 'api/TbmNew/GetTbmNewR1', // 최근 TBM 조회
      getTbmNewR2: 'api/TbmNew/GetTbmNewR2', // TBM 참가자 조회
      getTbmNewR3: 'api/TbmNew/GetTbmNewR3', // TBM 단계 조회
      getTbmNewR4: 'api/TbmNew/GetTbmNewR4', // 단계 마지막 교육 지점 조회
      getTbmNewR5: 'api/TbmNew/GetTbmNewR5', // TBM 세션 1건 조회(SESSION_CD)
      getTbmNewR8: 'api/TbmNew/GetTbmNewR8', // 교육 자료 조회
      getTbmNewR9: 'api/TbmNew/GetTbmNewR9', // content 마지막 교육 지점 조회
      getTbmNewR10: 'api/TbmNew/GetTbmNewR10', // TBM content 조회
      saveTbmNewU1: 'api/TbmNew/SaveTbmNewU1', // TBM 정보 저장
      saveTbmNewU2: 'api/TbmNew/SaveTbmNewU2', // TBM 참가자 저장
      saveTbmNewU3: 'api/TbmNew/SaveTbmNewU3', // TBM 단계 저장
      deleteTbmNewD1: 'api/TbmNew/DeleteTbmNewD1', // TBM 정보 삭제
      deleteTbmNewD2: 'api/TbmNew/DeleteTbmNewD2', // TBM 단계 삭제
      deleteTbmNewD3: 'api/TbmNew/DeleteTbmNewD3', // TBM 세션의 모든 참가자 삭제
      deleteTbmNewD4: 'api/TbmNew/DeleteTbmNewD4', // TBM 참가자 단일 삭제
    },
    /* 교육(Training) - TraCustomService */
    Training: {
      saveTraCustom02SessionSign: 'api/TraCustom/SaveTraCustom02U3', // 모바일 QR 참석 서명 저장
      bindTraCustom02QrSession: 'api/TraCustom/BindTraCustom02QrSession', // 임시 세션 → 교육일지 반영(웹 최종저장 시)
    },
    /* 외부인(비회원) 전자서명 — 서버에 AllowAnonymous + 엔드포인트 구현 필요 */
    ExternalSign: {
      saveExternalGuestSignU1: 'api/Utility/SaveExternalGuestSignU1',
    },
    Alarm: {
      GetAlarmList: 'api/AlaBasic/GetAlarmList', // 알림 리스트 조회
      SaveAllBasicU1: 'api/AlaBasic/SaveAllBasicU1', // 알림 읽기
      DeleteAlarmD1: 'api/AlaBasic/DeleteAlarmD1', // 알림 삭제
      GetAlaBasicR1: 'api/AlaBasic/GetAlaBasicR1', // 알림 설정 조회
      SaveAlaBasicSettingU1: 'api/AlaBasic/SaveAlaBasicSettingU1', // 알림 설정 저장
      SaveAlaBasicSettingU2: 'api/AlaBasic/SaveAlaBasicSettingU2', // 알림 설정 기본값 저장
    },
    Notice: {
      /* 공지사항 탭 */
      getNotBasicR1: 'api/NotBasic/GetNotBasicR1', //공지사항 목록 조회
      getNotBasic01R1: 'api/NotBasic/GetNotBasic01R1', //공지사항 목록 조회
      getNotBasicR2: 'api/Notice/GetNotBasicR2', //공지사항 파일 조회 SP_NOT_BASIC_01_R2 ======
      saveNotBasicU1: 'api/Notice/SaveNotBasicU1', //공지사항 저장 SP_NOT_BASIC_01_02_U0, SP_NOT_BASIC_01_02_U1 =====
      saveNotBasicU2: 'api/Notice/SaveNotBasicU2', //공지사항 저장 SP_NOT_BASIC_01_02_U2 ====
      deleteNotBasicD1: 'api/Notice/DeleteNotBasicD1', //공지사항 파일삭제 SP_NOT_BASIC_01_02_D2 =====
      deleteNotBasicD2: 'api/Notice/DeleteNotBasicD2', //공지사항 삭제 SP_NOT_BASIC_01_02_D1 =====
      /* 게시 탭 */
      getNotBasic02R1: 'api/Notice/GetNotBasic02R1', //게시조회 SP_NOT_BASIC_02_R1 ====
      getNotBasic02R2: 'api/NotBasic/GetNotBasic02R2', //게시조회 SP_NOT_BASIC_02_R2 ====
    },
    PolicyAndGoals: {
      getPolBasic01R2: 'api/PolBasic/GetPolBasic01R2',
      getPolBasic01R3: 'api/PolBasic/GetPolBasic01R3',
    },
    EmergencyManual: {
      getEmrBasic01R1: 'api/EmrBasic/GetEmrBasic01R1', // 비상대응메뉴얼 목록
      getEmrBasic01R2: 'api/EmrBasic/GetEmrBasic01R2', // 비상대응메뉴얼 상세
    },
    /* 작업시작 */
    WorkStart: {
      getAicCallR1: 'api/WorkStart/GetAicCallR1', // 보이스 체크 리스트 조회 SP_GetAICall1
      getEquipR1: 'api/WorkStart/GetEquipR1', // 보호구 조회(AiCall) SP_EQUIP_R1
      getEquipIssueR2: 'api/WorkStart/GetEquipIssueR2', // 보호구 조회(PPE) SP_EQUIP_ISSUE_R2
      getPpeBasic01R1: 'api/PpeBasic/GetPpeBasic01R1', //보호구등록 조회
      saveAicCallU1: 'api/WorkStart/SaveAicCallU1', // AI콜 음성 경로 DB저장 SP_AICall_U1
      saveWorkStartU1: 'api/WorkStart/SaveWorkStartU1', // 작업 시작 SP_M21101_U1
      saveEquipLogU1: 'api/WorkStart/SaveEquipLogU1', // 보호구 자가 체크 여부 저장 SP_EQUIP_LOG_U1
    },
    /* 작업중지 */
    WorkStop: {
      getWosBasicR1: 'api/WorkStopBasic/GetWosBasicR1', // 작업중지 목록 조회 *SP_WOS_BASIC_R1
      getWosBasicR2: 'api/WorkStopBasic/GetWosBasicR2', // 작업중지 상세 조회 *SP_WOS_BASIC_R2
      saveWosBasicU1: 'api/WorkStopBasic/SaveWosBasicU1', // 작업재개(사용자 확인) 저장 *SP_M10100_U1
      saveWosBasicU2: 'api/WorkStopBasic/SaveWosBasicU2', // 작업재개 승인/수정 저장 *SP_WOS_BASIC_U2
      getWosBasic01R1: 'api/WorkStopBasic/GetWosBasic01R1', // 작업중지 작성 - 사업장 조회 *SP_GET_AUTH_CUST_MANAGER
      getWosBasic01R2: 'api/WorkStopBasic/GetWosBasic01R2', // 작업중지 작성 - 부서 조회 *SP_GET_DEP_LAST
      getWosBasic01R3: 'api/WorkStopBasic/GetWosBasic01R3', // 작업중지 작성 - 부서 인원 조회 *SP_GET_DEP_MEMBER
      getWosBasic01R4: 'api/WorkStopBasic/GetWosBasic01R4', // 작업중지 작성 - 동일부서 결재권자 + 동일사업장 안전관리자 조회
      saveWosBasic01U1: 'api/WorkStopBasic/SaveWosBasic01U1', // 작업중지 작성 - 저장 *SP_WOS_BASIC_U1
      saveWosBasic01U2: 'api/WorkStopBasic/SaveWosBasic01U2', // 작업중지 멤버 저장 *SP_WOS_BASIC_U3
      getWosBasic03R1: 'api/WorkStopBasic/GetWosBasic03R1', // 작업중지 여부 조회 *SP_WOS_BASIC_R3
    },
    /* 작업종료 & 작업후기 */
    WorkEnd: {
      /* 작업종료 */
      getWoeBasicR1: 'api/WorkEndBasic/GetWoeBasicR1', // 작업종료시 알림 보낼 결재승인자 조회 (본인 제외, 승인자)
      saveWoeBasicU1: 'api/WorkEndBasic/SaveWoeBasicU1', // 작업종료 상세 및 시간 저장 *SP_WOE_BASIC_U1
      saveWoeBasicU2: 'api/WorkEndBasic/SaveWoeBasicU2', // 작업종료 상세 및 시간 저장 *SP_WOE_BASIC_U1
      /* 작업후기 */
      getWoeBasicR2: 'api/WorkEndBasic/GetWoeBasicR2', // 작업후기 목록 조회 *SP_WOE_BASIC_R2
      getWoeBasicR3: 'api/WorkEndBasic/GetWoeBasicR3', // 작업후기 상세 조회 *SP_WOE_BASIC_R3
      saveWoeBasicU3: 'api/WorkEndBasic/SaveWoeBasicU3', // 작업후기 저장 *SP_WOE_BASIC_U3
    },
    /* 회의록 */
    Meeting: {
      getMetBasicR1: 'api/MeetingBasic/GetMetBasicR1', // 사업장/권한 관리자 조회 SP_GET_AUTH_CUST_MANAGER
      getMetBasicR2: 'api/MeetingBasic/GetMetBasicR2', // 안전보건 협의체 회의록 조회 SP_SUB_BASIC_03_R2
      getMetBasicR3: 'api/MeetingBasic/GetMetBasicR3', // 산업안전보건위원회 회의록 조회 SP_SAC_BASIC_R6
      getMetBasic01R1: 'api/MeetingBasic/GetMetBasic01R1', // 상세 조회 대표 SP_SUB_BASIC_03_R8
      getMetBasic01R2: 'api/MeetingBasic/GetMetBasic01R2', // 상세 조회 참석자 C SP_SUB_BASIC_03_R4
      getMetBasic01R3: 'api/MeetingBasic/GetMetBasic01R3', // 상세 조회 참석자 I SP_SAC_BASIC_R4
      getMetBasic01R4: 'api/MeetingBasic/GetMetBasic01R4', // 불참 알림 대상 SP_SUB_BASIC_03_R6
      saveMetBasic01U1: 'api/MeetingBasic/SaveMetBasic01U1', // 대표 승인 SP_SUB_BASIC_03_U5
      saveMetBasic01U2: 'api/MeetingBasic/SaveMetBasic01U2', // 참석자 서명 C SP_SUB_BASIC_03_U4
      saveMetBasic01U3: 'api/MeetingBasic/SaveMetBasic01U3', // 참석자 서명 I SP_SAC_BASIC_U6
      saveMetBasic01U4: 'api/MeetingBasic/SaveMetBasic01U4', // 참석 여부 C SP_SUB_BASIC_03_U7
      saveMetBasic01U5: 'api/MeetingBasic/SaveMetBasic01U5', // 참석 여부 I SP_SAC_BASIC_U5
    },

    /* 교육 파일 */
    // File: {
    //   getFileCustomR1: 'api/File/GetFileCustomR1', // 교육 자료 조회 SP_FILE_R1
    //   getFileCustomR2: 'api/File/GetFileCustomR2', // 작업계획서 조회 SP_TBM_R5
    //   getFileCustomR3: 'api/File/GetFileCustomR3', // 작업허가서 조회 SP_TBM_R4
    // },
    Permit: {
      getPerBasicR4: 'api/PerBasic/GetPerBasicR4', // 작업허가서 상세 조회 *SP_PERMIT_R4
      getPerCustomR1: 'api/PerCustom/GetPerCustomR1', // 작업허가서 조회 *SP_PERMIT_CUSTOM_R1
      getPerCustomR3: 'api/PerCustom/GetPerCustomR3', // 작업허가서 상세 조회 *SP_PERMIT_CUSTOM_R3
      getPerCustomR4: 'api/PerCustom/GetPerCustomR4', // 결재승인자 조회 *SP_PERMIT_CUSTOM_R3
      getPerCustomR5: 'api/PerCustom/GetPerCustomR5', // 작업허가서 상세 조회 *SP_PERMIT_CUSTOM_R3
      getPerCustomR6: 'api/PerCustom/GetPerCustomR6', // 작업허가서 달력 상태 조회
      getPerCustomR7: 'api/PerCustom/GetPerCustomR7', // 최근 작업허가서 결재자 조회
      getPerCustomWorkType: 'api/PerCustom/GetPerCustomWorkType', // 작업종류 목록 조회
      getPerCustomWorkTypeDtl: 'api/PerCustom/GetPerCustomWorkTypeDtl', // 작업종류 상세 조회 (위험사항, 보호구, 준비사항) 조회
      savePerCustomU1: 'api/PerCustom/SavePerCustomU1', // 안전작업 허가서 저장
      savePerCustomU2: 'api/PerCustom/SavePerCustomU2', // 안전작업 허가서 결재승인자 사인 저장
      savePerCustomU3: 'api/PerCustom/SavePerCustomU3', // 안전작업 허가서 반려/사인 처리
      savePerCustomU4: 'api/PerCustom/SavePerCustomU4', // 안전작업 허가서 연장 신청
      deletePerCustomD1: 'api/PerCustom/DeletePerCustomD1', // 안전작업 허가서 삭제
      getPerNewR1: 'api/PerNew/GetPerNewR1', // 안전작업 허가서 조회
      getPerNewR2: 'api/PerNew/GetPerNewR2', // 사업장 코드 조회
      getPerNewR3: 'api/PerNew/GetPerNewR3', // 작업허가서 상세 조회
      getPerNewR4: 'api/PerNew/GetPerNewR4', // 작업허가서 최근결재선 조회
      getPerNewR5: 'api/PerNew/GetPerNewR5', // 달력 점 표시 조회
      getPerNewR6: 'api/PerNew/GetPerNewR6', // 플로팅뱃지 조회
      savePerNewU1: 'api/PerNew/SavePerNewU1', // 안전작업 허가서 저장
      savePerNewU2: 'api/PerNew/SavePerNewU2', // 안전작업 허가서 저장
      savePerNewU3: 'api/PerNew/SavePerNewU3', // 안전작업 허가서 저장
      savePerNewU4: 'api/PerNew/SavePerNewU4', // 안전작업 허가서 입회 저장
      savePerNewU5: 'api/PerNew/SavePerNewU5', // 안전작업 허가서 연장
      savePerNewU6: 'api/PerNew/SavePerNewU6', // 안전작업 허가서 연장
      deletePerNewD1: 'api/PerNew/DeletePerNewD1', // 안전작업 허가서 삭제
    },
    /* 안전보건제안 (WorkInfo) */
    WorkInfo: {
      getAccBasic02R1: 'api/AccBasic/GetAccBasic02R1', // 안전신문고 조회
      saveAccBasic02U1: 'api/AccBasic/SaveAccBasic02U1', // 안전보건제안 저장
      deleteAccBasic02D1: 'api/AccBasic/DeleteAccBasic02D1', // 안전보건제안 삭제
      getWoiBasicR2: 'api/WorkInfoBasic/GetWoiBasicR2', // 이미지 조회
      getWoiBasicR3: 'api/WorkInfoBasic/GetWoiBasicR3', // 사업장/관리자 목록 조회
      getWoiBasicR4: 'api/WorkInfoBasic/GetWoiBasicR4', // 상세 조회
      saveWoiBasicU1: 'api/WorkInfoBasic/SaveWoiBasicU1', // 안전보건제안 저장
      deleteWoiBasicD1: 'api/WorkInfoBasic/DeleteWoiBasicD1', // 안전보건제안 삭제
    },
    /* 문서 관리 */
    DocsManagement: {
      /** 안전보건방침 및 목표 */
      getPolBasicR1: 'api/PolBasic/GetPolBasicR1', //안전보건목표 및 추진계획 기본 조회
      getPolBasic02R1: 'api/PolBasic/GetPolBasic02R1', // 안전보건목표 및 추진계획 기본02 조회
      getPolBasic02R2: 'api/PolBasic/GetPolBasic02R2', //안전보건목표 및 추진계획 기본02 상세 조회
      /** 예산 편성 및 집행 */
      getBudBasicR2: 'api/BudBasic/GetBudBasicR2', //예산관리 기본02 조회
      getBudFileR1: 'api/BudBasic/GetBudFileR1', //예산관리 파일 조회
      /** 안전보건인력 */
      getSapBasic01R1: 'api/SapBasic/GetSapBasic01R1', //조직도 조회 기본 조회
      getSapBasic02R1: 'api/SapBasic/GetSapBasic02R1', //안전보건인력 기본 조회
      getSapBasic02R2: 'api/SapBasic/GetSapBasic02R2', //안전보건인력 평가표 조회
      /** 비상대응매뉴얼 */
      getEmrBasicR1: 'api/EmrBasic/GetEmrBasicR1', //비상대응매뉴얼 기본 조회
      /** 도급사업관리 */
      getSubBasic01R1: 'api/SubBasic/GetSubBasic01R1', //수급업체 기본 조회
      getSubBasicMst02R1: 'api/SubBasic/GetSubBasicMst02R1', //수급 평가표 조회
      getSubBasicMst01R2: 'api/SubBasic/GetSubBasicMst01R2', //수급 평가표 상세 조회
      getSubBasicMst03R1: 'api/SubBasic/GetSubBasicMst03R1', //수급 회의록 조회
      getSubBasicMst03R2: 'api/SubBasic/GetSubBasicMst03R2', //수급 회의록 결과 조회
      getSubBasicMst03R3: 'api/SubBasic/GetSubBasicMst03R3', //수급 회의록 상세 조회
      /** 법규준수평가 */
      getLegBasicR1: 'api/LegBasic/GetLegBasicR1', //법규준수 기본 조회
      getLegBasicR2: 'api/LegBasic/GetLegBasicR2', //법규준수 기본 상세 조회 (데이터가 없으면 템플릿 복사)
      /** 중대재해처벌법 이행관리 */
      getSerBasicR1: 'api/SerBasic/GetSerBasicR1', //중대재해처벌법 기본 조회
      getSerBasic01R1: 'api/SerBasic/GetSerBasic01R1', //중대재해처벌법 마스터 상세 조회
      getSerBasic01R2: 'api/SerBasic/GetSerBasic01R2', //중대재해처벌법 상세 정보 조회
      /** 산업안전보건위원회 */
      getSacBasicR1: 'api/SacBasic/GetSacBasicR1', // 안전보건위원회 기본 조회
      getSacBasicR2: 'api/SacBasic/GetSacBasicR2', // 안전보건위원회 회원 정보 조회
      getSacBasicR3: 'api/SacBasic/GetSacBasicR3', // 안전보건위원회 회의 결과 조회
      /** 위험성평가 */
      getRisBasic01R1: 'api/RisBasic/GetRisBasic01R1', //위험성평가 조회
      getRisBasic01R2: 'api/RisBasic/GetRisBasic01R2', //위험성평가 상세 조회
      getRisBasic02R1: 'api/RisBasic/GetRisBasic02R1', //위험성평가 결과서 조회
      getRisBasic02R2: 'api/RisBasic/GetRisBasic02R2', //위험성평가 체크리스트 조회
      /** 안전작업 관리 */
      getSamBasic01R1: 'api/SamBasic/GetSamBasic01R1', //작업계획서 기본 조회
      getSamBasic02R1: 'api/SamBasic/GetSamBasic02R1', //안전작업허가서 조회
      getSamBasic02R2: 'api/SamBasic/GetSamBasic02R2', // 안전작업허가서 상세 조회
      /** 보호구 관리 */
      getPpeBasic02R1: 'api/PpeBasic/GetPpeBasic02R1', //보호구관리대장 조회
      getPpeBasic03R1: 'api/PpeBasic/GetPpeBasic03R1', //보호구지급대장 조회
      /** 유해위험기계기구 */
      getHazBasic01R2: 'api/HazBasic/GetHazBasic01R2', //유해위험기계기구 기본 조회
      getHazBasic03R1: 'api/HazBasic/GetHazBasic03R1', //유해위험기계기구(점검) 기본 조회
      /** TBM */
      getTraCustom01R1: 'api/TraCustom/GetTraCustom01R1', // 교육현황 조회
      getTraCustom01R2: 'api/TraCustom/GetTraCustom01R2', // 참석자 조회
      getTraCustom05R1: 'api/TraCustom/GetTraCustom05R1', // TBM 조회 * 기존 프로시저 : SP_TRA_BASIC_01_R1
      getTraCustom05R2: 'api/TraCustom/GetTraCustom05R2', // TBM 참석자 조회 * 기존 프로시저 : SP_TRA_BASIC_01_R2
      /** 안전보건교육 */
      getSatBasic03R1: 'api/SatBasic/GetSatBasic03R1', // 연간교육계획표 조회
      getTraCustom02R1: 'api/TraCustom/GetTraCustom02R1', // 교육일지 조회
      getTraCustom02R2: 'api/TraCustom/GetTraCustom02R2', // 교육일지 참석자 조회
      saveTraCustom02ApproverSign: 'api/TraCustom/SaveTraCustom02ApproverSign', // 교육일지 중간/최종 결재 서명
      saveTraCustom02ApproverReject:
        'api/TraCustom/SaveTraCustom02ApproverReject', // 교육일지 중간/최종 결재 반려
      getSatBasic05R1: 'api/SatBasic/GetSatBasic05R1', // 교육이수현황 조회
      getSatBasic05R2: 'api/SatBasic/GetSatBasic05R2', // 교육이수현황 조회
      getSatBasic07R1: 'api/SatBasic/GetSatBasic07R1', // 교육관리(대상자별) 조회
      /** 유해위험물질 */
      getHamBasic01R1: 'api/HamBasic/GetHamBasic01R1', // 유해위험물질 기본 조회
      getHamBasic02R1: 'api/HamBasic/GetHamBasic02R1', // MSDS 관리대장 조회
      /** 일반/특수 건강진단 */
      getHeaBasic01R1: 'api/HeaBasic/GetHeaBasic01R1', //일반건강진단 기본 조회
      getHeaBasic02R1: 'api/HeaBasic/GetHeaBasic02R1', //특수건강진단 기본 조회
      /** 작업환경측정 */
      getWorBasicR1: 'api/WorBasic/GetWorBasicR1', //작업환경측정 기본 조회
      /** 산업재해 보고 및 기록 */
      getAccBasicR1: 'api/AccBasic/GetAccBasicR1', //산업재해 보고 및 기록 기본 조회
    },
    /* 보호구 수령현황 */
    EquipIssuanceStatus: {
      getEisBasicR1: 'api/EisBasic/GetEisBasicR1', // 보호구 수령현황 조회 SP_M_EIS_BASIC_R1
      saveEisBasicU1: 'api/EisBasic/SaveEisBasicU1', // 보호구 수령현황 저장 SP_M_EIS_BASIC_U1
    },
    /* 보호구 지급 */
    EquipIssuance: {
      getMemBasicR1: 'api/Member/GetMemBasicR1', //인력 조회 SP_MEM_BASIC_R1
      getEicBasicR1: 'api/EicBasic/GetEicBasicR1', //인력 조회
      getPpeBasic01R1: 'api/PpeBasic/GetPpeBasic01R1', //보호구등록 조회 SP_PPE_BASIC_03_R1
      saveEicBasicU1: 'api/EicBasic/SaveEicBasicU1', // 근로자별 보호구 저장 SP_EQUIP_ISSUE_U1
    },
    EmergencyTel: {
      GetEmTelR1: 'api/EmtBasic/GetEmTelR1', // 비상연락망 조회 SP_EMTEL_R1
      SaveEmTelU1: 'api/EmtBasic/SaveEmTelU1', // 비상연락망 등록/해제
    },
    // 나의 결재 대기
    PendingApprovals: {
      getPeaBasicR1: 'api/PeaBasic/GetPeaBasicR1',
    },
    /* FTP */
    Ftp: {
      ftpRequest: 'api/Ftp/FtpRequest', //FTP 업로드
      ftpResponse: 'api/Ftp/FtpResponse', //FTP 다운로드
    },
    /* FILE 서버 */
    File: {
      videoUpload: 'api/File/VideoUpload', //파일서버 업로드
      UploadChunk: 'api/File/UploadChunk', //파일서버 대용량 업로드 - Chunk
      MergeChunks: 'api/File/MergeChunks', //파일서버 대용량 업로드 - MergeChunk
      UrlFileDownload: 'api/File/UrlFileDownload', //파일 다운로드
      DeleteFile: 'api/File/DeleteFile', //파일 삭제
      ConvertHwpToPdf: 'api/File/ConvertHwpToPdf', //한글 -> PDF 변환
      ConvertOfficeToPdf: 'api/File/ConvertOfficeToPdf', //Office파일 -> PDF 변환(한글 제외)
      moveAndReplaceFile: 'api/File/moveAndReplaceFile', //Preview 파일 이동/삭제
    },
    FCM: {
      fcm: 'api/FCM/PostFcmServer', //FCM 서버 호출
    },
    Reports: {
      reports: 'api/Reports/GetReports', //report 호출
      businessDown: 'api/Reports/GetFile',
    },
  },
};
